import { styled } from '@maistodos/design-system-web'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: ${({ theme }) => theme.spacings.spacing16};
  color: ${({ theme }) => theme.colors.neutral400};
`
